import React from 'react';

import { observer } from 'mobx-react-lite';
import { RequestDelayType } from 'stores/request_delay_store';
import useStores from 'hooks/useStores';


type RequestDelayContextType = {

    // Fetch and get one
    fetchListByRequest: (identity: string, request: string) => Promise<RequestDelayType[]>;
    getListByRequest: (request: string) => RequestDelayType[];

    // cancel delay
    doCancel: (workKey: string, request: string) => Promise<RequestDelayType|null>;

    // Contains all known RequestDelay items
    items: RequestDelayType[];
}

export const RequestDelayContext = React.createContext<RequestDelayContextType>({
    fetchListByRequest: () => { throw 'Not Implemented fetchListByRequest' },
    getListByRequest: () => { throw 'Not Implemented getListByRequest' },
    doCancel: () => { throw 'Not Implemented doCancel' },
    items: [] as RequestDelayType[],
});



export const RequestDelayProvider = observer(({ children }: { children: React.ReactNode }) => {
    const { requestDelayStore } = useStores();

    const fetchListByRequest = async (identity: string, request: string) => {
        return requestDelayStore.fetchListByRequest(identity, request)
            .then(() => {
                return getListByRequest(request);
            });
    };

    const getListByRequest = (request: string) => {
        return requestDelayStore.items.slice().filter((item) => item.request === request);
    };

    const doCancel = async (workKey: string, request: string) => {
        return requestDelayStore.doCancel(workKey, request);
    };


    const data = {
        fetchListByRequest,
        getListByRequest,
        doCancel,
        items: requestDelayStore.items,
    };

    return (
        <RequestDelayContext.Provider value={data}>{ children }</RequestDelayContext.Provider>
    );

});
